/**
 * @name 回森短链
 * @author Li Wei<liwei03@kuaishou.com>
 * @date 2021.06.24 15:22:02
 * @document https://docs.corp.kuaishou.com/k/home/VTt7yvsPcjbo/fcAB9zY1RuJB8Wmc7VpzIllX8
 */
import { openAppToast } from './bridge';
import { getQueryValue, isInApp, compareAppVersion } from './utils';

const Scheme = 'imv';
const ptfrom = isInApp() ? 'imv' : 'share';

export function useScheme(url, jump = true, version) {
    // ptfrom用来区分唤起App的来源 目前先统一写share 后续根据需要再做区分
    url += `${url.indexOf('?') !== -1 ? '&' : '?'}ptfrom=${ptfrom}`;

    const fromId = getQueryValue('fromId');
    if(fromId){
        url += `&fromId=${fromId}`;
    }

    if (jump) {
        if(isInApp() && version && !compareAppVersion(version)){
            openAppToast(`您的App版本过低，请升级到${version}以上版本使用此功能`);
        }else{
            window.location.href = url;
        }
    } else {
        return url;
    }
}

// 跳转到App的推荐Tab
export const gotoAppTabFeed = (param = {}) => {
    const {tab = 'reco', expectBottleType, jump} = param;
    const url = `${Scheme}://tab/feed?tab=${tab}${expectBottleType ? `&expectBottleType=${expectBottleType}` : ''}`;
    return useScheme(url, jump);
};

// 跳转到App作品详情页
export const gotoAppWorkDetail = ({ id, jump }) => {
    let url = `${Scheme}://item?id=${id}`;
    if (!id) {
        return gotoAppTabFeed();
    }

    return useScheme(url, jump);
};

// 跳转到动态详情页
export const gotoMomentDetail = ({ id, jump }) => {
    let url = `${Scheme}://moment?id=${id}`;
    if (!id) {
        return gotoAppTabFeed();
    }

    return useScheme(url, jump);
};

// 跳转到App用户详情页
// 如果获取 id 成功, 则返回用户详情页
// 否则返回 feed 页面
export const gotoAppUserProfile = ({ id, tab = 'work', jump }) => {
    const url = `${Scheme}://user?${tab ? `tab=${tab}` : ''}${id ? `&id=${id}` : ''}`;
    // if (!id) {
        // return gotoAppTabFeed();
    // }

    return useScheme(url, jump);
};

// 跳转到App话题聚合页
export const gotoAppTopic = ({ name, id, jump }) => {
    const url = `${Scheme}://topic?name=${window.encodeURIComponent(name)}${id ? `&id=${id}` : ''}`;
    return useScheme(url, jump);
};

// 跳转到App歌曲作品聚合页
export const gotoAppMusicWork = ({ id, tab = 'reco', jump }) => {
    const url = `${Scheme}://music?id=${id}&tab=${tab}`;
    return useScheme(url, jump);
};

// 跳转到App演唱页
export const gotoAppMusicSing = ({ id = '', tab = '', type = '', item_id = '', activity_id, template_id, publish_desc, extra_info, tips = '', jump }) => {
    let url = `${Scheme}://sing?id=${id}`;
    if (tab) {
        url += `&tab=${tab}`
    }
    if (type) {
        url += `&type=${type}`
    }
    if (item_id) {
        url += `&item_id=${item_id}`
    }
    if (activity_id) {
        url += `&activity_id=${activity_id}`
    }
    if (template_id) {
        url += `&template_id=${template_id}`
    }
    if (publish_desc) {
        url += `&publish_desc=${encodeURIComponent(publish_desc)}`
    }
    if (extra_info) {
        url += `&extra_info=${JSON.stringify(extra_info)}`
    }
    if (tips) {
        url += `&tips=${encodeURIComponent(tips)}`
    }
    return useScheme(url, jump);
};

// 跳转到App森友Tab
export const gotoAppTabFriend = (jump) => {
    const url = `${Scheme}://senyou`;
    return useScheme(url, jump);
};

// 跳转到App点唱Tab
export const gotoAppTabKtv = (jump) => {
    const url = `${Scheme}://tab/ktv`;
    return useScheme(url, jump);
};

// 自定义跳转到App具体的tab
export const gotoAppTabKtvByName = (name,jump) => {
    const url = `${Scheme}://tab/ktv?tabName=${ name }`;
    return useScheme(url, jump);
};

// 跳转到App聊天Tab私信页
export const gotoAppPrivateLetter = (jump) => {
    const url = `${Scheme}://chat`;
    return useScheme(url, jump);
};

// 跳转到App聊天Tab互动消息 [0:全部 1:评论 2:弹幕 10:@ 3：点赞 4：粉丝]
export const gotoAppInteractTab = ({ tabIndex = 0, jump }) => {
    const url = `${Scheme}://message?tab=${tabIndex}`;
    return useScheme(url, jump);
};

// 跳转到App意见反馈
export const gotoAppFeedback = (jump) => {
    const url = `${Scheme}://tab/chat?id=666`;
    return useScheme(url, jump);
};

// 新开App webview打开H5
export const openAppWebview = ({url, jump}) => {
    const schemeUrl = `${Scheme}://web?isHome=1&url=${window.encodeURIComponent(url)}`;
    return useScheme(schemeUrl, jump);
};

// 跳转到App快唱页
export const gotoAppQuickSing = (jump) => {
    const url = `${Scheme}://quicksing`;
    return useScheme(url, jump);
};

// 跳转到个人资料编辑页
export const gotoAppUserEdit = (jump) => {
    const url = `${Scheme}://user/edit`;
    return useScheme(url, jump);
};

// 打开 im 聊天界面
export const  gotoImChat = ({id, jump}) => {
    return useScheme(`${Scheme}://tab/chat?id=${id}`, jump)
}

// 跳转到精选tab
export const gotoAppPlaylist = (jump) => {
    const url = `${Scheme}://tab/playlist`;
    return useScheme(url, jump);
};

// 个人作品feeda
export const gotoAppUserFeed = ({id, jump}) => {
    let url = `${Scheme}://user/feed`;
    if (id) {
        url += `?id=${id}`
    }
    return useScheme(url, jump);
};

// 加入房间
export const joinAppRoom = ({id = '', owner = '', expireTime, st, autoOpenGiftBag, autoOpenGiftTab, jump}) => {
    let url = `${Scheme}://room?id=${id}&owner=${owner}${expireTime ? `&expireTime=${expireTime}` : ''}${st ? `&st=${st}` : ''}${autoOpenGiftBag ? `&autoOpenGiftBag=${autoOpenGiftBag}` : ''}${autoOpenGiftTab ? `&autoOpenGiftTab=${autoOpenGiftTab}` : ''}`;
    return useScheme(url, jump);
};

// 天团主页
export const gotoAppGroup = ({id = '', jump}) => {
    let url = `${Scheme}://group?id=${id}`;
    return useScheme(url, jump);
};

// 创建天团页
export const createAppGroup = (jump) => {
    let url = `${Scheme}://group/create`;
    return useScheme(url, jump);
};

// 接龙tab
export const gotoAppTabJielong = (jump) => {
    let url = `${Scheme}://tab/jielong`;
    return useScheme(url, jump);
};

// 天团成员列表页
export const gotoAppGroupMembers = ({id = '', jump}) => {
    let url = `${Scheme}://group/user/list?id=${id}`;
    return useScheme(url, jump, '3.21.0');
};

// 校园主页
export const gotoAppSchool = ({id = '', jump}) => {
    let url = `${Scheme}://campus/detail?school_id=${id}`;
    return useScheme(url, jump);
};

// chirp个人页
export const gotoAppChirpProfile = ({id = '', jump}) => {
    let url = `${Scheme}://chirp/profile?id=${id}`;
    return useScheme(url, jump);
};

// chirp详情页
export const gotoAppChirpDetail= ({id = '', jump}) => {
    let url = `${Scheme}://chirp/item?id=${id}`;
    return useScheme(url, jump);
};

// 音色测试录制页
export const gotoAppTimbreRecord = ({id = '', jump}) => {
    let url = `${Scheme}://timbre/record?channelId=${id}`;
    return useScheme(url, jump, '3.51.8');
};

// 跳转歌房feed
export const gotoAppTabRoom = (jump) => {
    let url = `${Scheme}://tab/room`;
    return useScheme(url, jump);
};

// 跳转哄哄话题列表
export const gotoAppHongTopicList = (jump) => {
    let url = `${Scheme}://chatgame/main_topic_list`;
    return useScheme(url, jump, '3.66.5');
};

// 跳转设置聊天气泡
export const gotoAppChatSkinSetting = ({ userId, userName, headUrl, jump }) => {
    let url = `${Scheme}://krn?bundleId=IMVChatSetting&componentName=ChatMessageSetting&targetId=${userId}&targetName=${encodeURIComponent(userName)}&targetHeaderUrl=${encodeURIComponent(headUrl)}`;
    return useScheme(url, jump);
};

// 跳转设置聊天背景
export const gotoAppChatBackgroundSetting = ({ userId, userName, headUrl, jump }) => {
    let url = `${Scheme}://krn?bundleId=IMVChatSetting&componentName=IntimateBgSettingPage&targetId=${userId}&targetName=${encodeURIComponent(userName)}&targetHeaderUrl=${encodeURIComponent(headUrl)}`;
    return useScheme(url, jump);
};

/**
 * 进入歌房或个人页
 * @param {Number} userId 用户ID
 * @param {Array} roomId 房间ID
 * @param {String} roomOwnerId 房主ID
 */
export const gotoRoomOrProfile = (userId, roomId, roomOwnerId, param = {}) => {
    if(roomId){
        joinAppRoom({ id: roomId, owner: roomOwnerId, ...param });
    }else{
        if(userId){
            gotoAppUserProfile({ id: userId });
        }
    }
};

/**
 * 进入歌房或个人页
 * @param {Number} userId 用户ID
 * @param {Array} roomId 房间ID
 * @param {String} roomOwnerId 房主ID
 * @param {String} invisible 是否神秘人
 */
export const gotoRoomOrProfileExcludeInvisible = (userId, roomId, roomOwnerId, invisible = false, otherParam = {}) => {
    if(!invisible){
        if(roomId){
            joinAppRoom({ id: roomId, owner: roomOwnerId,  ...otherParam });
        }else{
            if(userId){
                gotoAppUserProfile({ id: userId });
            }
        }
    }else{
        openAppToast('对方开启神秘人特权，无法查看个人主页');
    }
};

// 跳转礼物图鉴
export const gotoAppGiftBook = (userName, userId, userHead, catalogueId, jump) => {
    let url = `${Scheme}://social/usercenter/giftcodex?userName=${encodeURIComponent(userName)}&userId=${userId}&catalogueId=${catalogueId}&userHead=${encodeURIComponent(userHead)}`;
    return useScheme(url, jump, '3.104.0');
};

// 加入合唱
export const gotoAppSingDuet = ({musicId, itemId, publish_desc, jump}) => {
    let url = `${Scheme}://sing/duet?musicId=${musicId}&itemId=${itemId}`;
    if(publish_desc){
        url = url + `&publish_desc=${encodeURIComponent(publish_desc)}`;
    };
    return useScheme(url, jump, '3.107.0');
};

// 跳转动态发布
export const gotoDynamicIssue = (params = {}) => {
    let url = `${Scheme}://social/publish_moments`;

    if(params?.topic){
        url = url + `?topic=${encodeURIComponent(params?.topic)}`;
    }
   
    return useScheme(url, params?.jump, '3.126.0');
};